namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_ai_request, {
		
		background: {
			color: $mol_theme.card,
		},
		Controls: {
			padding: $mol_gap.block,
			flex: {
				direction: 'column',
			},
		},

		Buttons: {
			flex: {
				direction: 'column',
			},
			margin: {
				top: '1rem',
			},
			gap: '0.75rem',
		},

		Copy: {
			background: {
				color: $mol_theme.back,
			},
			color: $mol_theme.text,
			flex: {
				grow: 0,
			},
			justify: {
				content: 'center',
			},
		},

		Paste: {
			justify: {
				content: 'center',
			},
		},

		Next: {
			justify: {
				content: 'center',
			},
		},
		Next_right_icon: {
			padding: {
				top: '0.25rem',
			},
			width: '1.5rem',
		},

		Request_type: {
			Option_label: {
				whiteSpace: 'normal',
			},
			Bubble_pane: {
				maxWidth: '20rem',
			},
		},
		
	} )
	
}
